export const days = 'dagar';
export const weekLabel = 'Veckovis';
export const weekShortLabel = 'vecka';
export const monthLabel = 'Månadsvis';
export const monthShortLabel = 'mån';
export const month = 'månad';
export const yearLabel = 'Årsvis';
export const yearShortLabel = 'år';
export const small = 'Small';
export const medium = 'Medium';
export const large = 'Large';
